import {filter, sortBy} from 'ramda';

import type {EagColumnState} from '../../types/EagColumnState';
import {useEagGridSelector} from '../useEagGridSelector';
import {withColumnStatesCache} from './withColumnStatesCache';

// Factory that creates a cached column selector hook.
// Each call produces its own private cache (via withColumnStatesCache) so
// selectors cannot collide on the same cache key even when multiple selectors
// share the same input array reference.
export function createCachedColumnSelector(
  predicate: (col: EagColumnState) => boolean
): () => EagColumnState[] {
  const selector = withColumnStatesCache((columnStates) =>
    // Ramda filter for predicate, Ramda sortBy for ordering.
    sortBy((col: EagColumnState) => col.order, filter(predicate, columnStates))
  );

  return function useCachedColumnSelector(): EagColumnState[] {
    return useEagGridSelector(selector);
  };
}
